import { Buttons, FlexContainer, Inputs, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import PasswordValidation from 'Components/PasswordValidation';
import { GradientBg, AuthContainer } from 'Components/UI';
import AppHeader from 'Components/AppHeader';
import { model } from './model';
import { RecoverPasswordProps } from './types';

const View = ({
  formValues,
  onSubmit,
  onChange,
  isValidForm,
}: RecoverPasswordProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.AUTH);
  return (
    <>
      <AppHeader />
      <GradientBg>
        <AuthContainer>
          <FlexContainer direction="column" gap="dimension_24">
            <Text color="dark" size="S_L_S" type="headline" align="center">
              {t('RecoverPassword.title')}
            </Text>
            <Inputs.InputForm
              inputForm={{ ...model.password, label: t(model.password.label) }}
              value={formValues.password.value}
              onChange={(value, isValid) => onChange({ id: model.password.id, value, isValid })}
              testID="password"
            />
            <FlexContainer direction="column" gap="dimension_16">
              <PasswordValidation password={formValues.password.value} />
              <Buttons.Classic
                label={t('common:Button.continue')}
                type="submit"
                testID="signUpSubmit"
                mode="primary"
                size="l"
                fullWidth
                onClick={onSubmit}
                disabled={!isValidForm}
              />
            </FlexContainer>
          </FlexContainer>
        </AuthContainer>
      </GradientBg>
    </>
  );
};

export default View;
